import axios from 'axios'
import React, { Component } from 'react'
import '../styles/Statistics.css'
import styled from 'styled-components'

export const StateImg = styled.div `
    background-color: ${props => props.dif === 2 || props.dif === 4 ? "aliceblue" : "antiquewhite" };
    border-bottom: 5px solid ${props => props.dif === 2 || props.dif === 4 ? " #3558aec7" : "var(--subColor)" };
    border-right: 5px solid ${props => props.dif === 2 || props.dif === 4 ? " #3558aec7" : "var(--subColor)" };
`
export const Number = styled.div `
    color: ${props => props.dif === 2 || props.dif === 4 ? " var(--subColor)" : "var(--mainColor)" };
`
export default class Statistics extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            statistics : []
        }
    }
    componentDidMount(){
        axios.get('../js/Data.json').then((res) => {this.setState({
            statistics : res.data.statistics
        })})
    }
    render() {
        const {statistics} = this.state
        const staticCard = statistics.map((item) => {
            return (
                <div className="col-md-3 col-6" key={item.ID}>
                    <div className="stats-card">
                        <Number className="number" dif={item.ID}>{item.number}</Number>
                        <StateImg className="state-img" dif={item.ID}>
                            <img src={item.image} alt="image"/>
                        </StateImg>
                        <div className="state">
                            <b>{item.state}</b>
                            <p>
                                {item.state_number}
                            </p>
                        </div>
                    </div>
                </div>
            )
        })
        return (
            <>
                <div className="statistics pd">
                    <div className="container">
                        <h3 className="title">Statistics</h3>
                        <div className="row">
                            {staticCard}
                        </div>
                    </div>
                </div>
                        
            </>
        )
    }
}
